/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/** Get the structured schema descriptor (fields + hints + limits). */
export const getVoiceDiarySchema = async () => (await api.get('/voice-diary/schema')).data;

/** Parse a raw transcript with Claude → structured JSON. */
export const parseTranscript = async (transcript) =>
  (await api.post('/voice-diary/parse', { transcript })).data;

/** Save (or re-save) a note. If structured is empty, backend re-parses. */
export const saveNote = async ({ transcript, structured, patient_id = null, patient_label = null, tags = [] }) =>
  (await api.post('/voice-diary/save', { transcript, structured, patient_id, patient_label, tags })).data;

/** List my notes (paginated, optional patient filter). */
export const listNotes = async ({ patientId = null, limit = 20, skip = 0 } = {}) => {
  const params = new URLSearchParams();
  if (patientId) params.set('patient_id', patientId);
  params.set('limit', String(limit));
  params.set('skip', String(skip));
  return (await api.get(`/voice-diary/list?${params.toString()}`)).data;
};

/** Update a note (structured / patient linkage / tags). */
export const updateNote = async (noteId, patch) =>
  (await api.put(`/voice-diary/${noteId}`, patch)).data;

/** Delete a note. */
export const deleteNote = async (noteId) =>
  (await api.delete(`/voice-diary/${noteId}`)).data;
